import React, { ReactElement } from 'react'
import {
    Maybe,
    SimpleProduct,
    ConfigurableProduct,
    GroupedProduct
} from '@pylot-data/fwrdschema'

import { ProductPrice } from '@components/common/ProductPrice/ProductPrice'
import Link from 'next/link'
import cn from 'classnames'
import Image from '@corratech/pylot-image'
import s from './SearchAutocomplete.module.scss'
import { getPDPUrl } from '@lib/getPDPUrl'
export type ProductItemProp = {
    product?: Maybe<ConfigurableProduct | SimpleProduct | GroupedProduct>
}

const ProductItemTiny = ({ product }: ProductItemProp): ReactElement | null => {
    if (!product) return null

    return (
        <div className={s['autocomplete-product-tiny']}>
            <Link href={getPDPUrl(product.url_key!)}>
                <div className={cn(s['autocomplete-product-img'])}>
                    <Image
                        src={product.small_image?.url!}
                        width={100}
                        height={100}
                    />
                </div>
            </Link>
            <div className={s['autocomplete-product-tiny-name']}>
                {product?.product_eyebrow_badge_text && (
                    <div className={cn(s['product-eyebrow'])}>
                        <span
                            className={cn(
                                'default-badge',
                                product?.product_eyebrow_badge_text &&
                                    String(
                                        product?.product_eyebrow_badge_text
                                    ).toLowerCase()
                            )}
                        >
                            {product.product_eyebrow_badge_text}
                        </span>
                    </div>
                )}
                <div>
                    <Link href={getPDPUrl(product.url_key!)}>
                        {product.name}
                    </Link>
                </div>
                <ProductPrice
                    priceRange={product?.price_range}
                    productType={product.__typename}
                />
            </div>
        </div>
    )
}
export default ProductItemTiny
